import { Component, HostListener, Input } from '@angular/core';
import { IAppState } from '../../app.state';
import { Store, select } from '@ngrx/store';
import { closeDialog } from './dialogs.actions';

@Component({
  selector: 'nns-dialog',
  template: `
    <div class="nns-dialog-content" (clickOutside)="onClickOutside()">
      <div class="nns-dialog-close" *ngIf="dialogOptions.showClose" (click)="close()">
        <nns-icon icon="close-s"></nns-icon>
      </div>
      <div class="nns-dialog-title" *ngIf="dialogOptions.title">{{dialogOptions.title}}</div>
      <div class="nns-dialog-container-wrapper">
        <ng-container
          *ngIf="dialogOptions.component"
          [ngxComponentOutlet]="dialogOptions.component"
        ></ng-container>
        <div class="nns-dialog-text"
          *ngIf="dialogOptions.text"
          [innerHtml]="dialogOptions.text">
        </div>
      </div>
      <div class="nns-dialog-actions">
        <div class="nns-cancel-button" *ngIf="!dialogOptions.hideCancelButton" (click)="close()">
          Cancel
        </div>
        <div class="nns-save-button" (click)="onSuccess()">
          {{dialogOptions.okButtonText ? dialogOptions.okButtonText : 'Ok'}}
        </div>
      </div>
    </div>
  `,
  styles: [`
    :host{
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 1000;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .nns-dialog-content{
      background-color: #fff;
      z-index: 1;
      box-shadow: 0 3px 41px 0 rgba(0, 0, 0, 0.26);
      padding: 24px;
      width: 490px;
      max-width: 90%;
      display: block;
      position: relative;
      border-radius: 4px;
    }
    .nns-dialog-title{
      margin-bottom: 24px;
      font-weight: bold;
      font-size: 16px;
    }
    .nns-dialog-text{
      font-size: 13px;
    }
    .nns-dialog-actions{
      display: flex;
      justify-content: flex-end;
      margin-right: -8px;
      margin-left: -8px;
      margin-top: 24px;
    }
    .nns-save-button{
      background-color: #0096a7;
      padding: 8px 11px;
      color: #fff;
      font-size: 13px;
      font-weight: bold;
      box-sizing: border-box;
      cursor: pointer;
      border-radius: 16px;
    }
    .nns-cancel-button{
      background-color: rgba(0, 161, 183, 0.1);
      padding: 8px 11px;
      margin-right: 10px;
      color: #00a1b7;
      font-size: 13px;
      font-weight: bold;
      cursor: pointer;
      border-radius: 16px;
    }
    .nns-dialog-close{
      position: absolute;
      cursor: pointer;
      right: 4px;
      top: 4px;
    }

  `, `
    :host-context(.nns-theme-night) .nns-dialog-content {
      background: #292E32;
      border-color: #161A1E;
      box-shadow: 4px 4px 38px rgba(19, 30, 32, 0.66);
    }
  `]
})

export class DialogComponent {
  @Input() public dialogOptions;

  clickOutsideNum = 0

  constructor(public _store: Store<IAppState>) {}

  onClickOutside() {
    if(this.clickOutsideNum > 0) {
      this.close()
    }
    this.clickOutsideNum++;
  }

  close() {
    this._store.dispatch(closeDialog());
  }

  onSuccess() {
    this.dialogOptions.onSuccess();
  }

  @HostListener('document:keydown.esc', ['$event'])
  closeFullScreen() {
    this.close();
  }
}
